import React from "react"
import { css } from "styled-components"
import Block from "../../atoms/layout-primitives/block"
import VariantContainer from "../../atoms/variant-container"
import { Alignments } from "../../molecules/icon-title"
import {
  ContentfulIconTitleCard,
  IContentfulIconTitleCard,
} from "../../molecules/icon-title-card"
import { T } from "../../styles/typography"

const FeatureGridRow = ({
  features,
}: {
  features: IContentfulIconTitleCard[]
}) => {
  return (
    <Block>
      <VariantContainer
        variants={[
          css`
            display: grid;
            justify-content: center;
            grid-gap: 32px;
          `,
          css`
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-column-gap: 24px;
            grid-row-gap: 32px;
            & > * {
              grid-row: 1;
              grid-column: span 2;
              :last-child {
                grid-row: 2;
                grid-column: 2 / 4;
              }
            }
          `,
          css`
            grid-template-columns: 1fr 1fr 1fr;
            grid-column-gap: 48px;
            margin: 0 3.88%;
            & > *,
            & > *:last-child {
              grid-column: unset;
              grid-row: 1;
            }
            text-align: center;
          `,
        ]}
      >
        {features.map((feature, index) => (
          <ContentfulIconTitleCard
            key={index}
            titleTag="h3"
            titleAlignmentVariants={[Alignments["column-centered"]]}
            titleVariants={[T.sm.h3`500`, T.md.h3`500`, T.lg.h4`500`]}
            iconVariants={{
              sm: { width: "32px", height: "32px" },
              lg: { width: "48px", height: "48px" },
            }}
            {...feature}
          />
        ))}
      </VariantContainer>
    </Block>
  )
}

export default FeatureGridRow
